import { forwardRef } from 'react';

import { ClassicEditor } from 'ckeditor5';
import { EDITOR_DEFAULT_CONFIG } from './config';
import { TextEditorWrapper } from './styled';

import 'ckeditor5/ckeditor5.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';

export type EditorType = CKEditor<ClassicEditor>;

type Props = {
  value?: string;
  onValueChange?: (value: string) => void;
  config?: EditorType['props']['config'];
  withoutToolbar?: boolean;
  readonly?: boolean;
  minHeight?: string | number;
  border?: string;
  borderTop?: string;
  padding?: string;
  backgroundColor?: string;
  overflow?: string;
} & Partial<EditorType['props']>;

//TODO: добавить динамический импорт
//TODO: пофиксить ошибку в консоли при выборе изображения
export const TextEditor = forwardRef<CKEditor<ClassicEditor>, Props>(
  (
    {
      onValueChange,
      value,
      withoutToolbar = false,
      readonly = false,
      config = EDITOR_DEFAULT_CONFIG,
      disabled,
      minHeight,
      border,
      borderTop,
      padding,
      backgroundColor,
      overflow,
      ...props
    }: Props,
    ref
  ) => {
    const onChangeHandler: EditorType['props']['onChange'] = (_, editor) => {
      if (!onValueChange || !editor || !editor.getData) return null;
      const data = editor.getData();
      onValueChange(data);
    };

    return (
      <TextEditorWrapper
        isDisabled={readonly ? false : !!disabled}
        isReadonly={readonly}
        minHeight={minHeight}
        border={border}
        borderTop={borderTop}
        padding={padding}
        backgroundColor={backgroundColor}
        overflow={overflow}
      >
        <CKEditor
          disabled={readonly || !!disabled}
          ref={ref}
          editor={ClassicEditor}
          config={{ ...config, toolbar: withoutToolbar ? undefined : config?.toolbar }}
          data={value as string}
          onChange={onChangeHandler}
          {...props}
        />
      </TextEditorWrapper>
    );
  }
);
